/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Unlock",
  size: 20
}

const SvgUnlock = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M3.5 8.5h13v10h-13zM6.5 8.5V4.9C6.5 3 8.1 1.5 10 1.5s3.5 1.5 3.5 3.4"
    />
  </Svg>
)

SvgUnlock.defaultProps = defaultProps
export default SvgUnlock
